export default __webpack_public_path__ + "static/media/photo 8.fd875232.jpg";